import axios from 'axios';

import { API_URL } from './baseApi';

export const pushNotificationApi = {
  save: async (subscription: PushSubscription) => await axios.post(`${API_URL}/push-notification/save`, subscription),
};
